import { render, staticRenderFns } from "./Meeting.vue?vue&type=template&id=2d1e8a35&scoped=true&lang=pug&"
import script from "./Meeting.vue?vue&type=script&lang=js&"
export * from "./Meeting.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.vue?vue&type=style&index=0&id=2d1e8a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e8a35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1e8a35')) {
      api.createRecord('2d1e8a35', component.options)
    } else {
      api.reload('2d1e8a35', component.options)
    }
    module.hot.accept("./Meeting.vue?vue&type=template&id=2d1e8a35&scoped=true&lang=pug&", function () {
      api.rerender('2d1e8a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/Meeting.vue"
export default component.exports